const KeenSlider = window.KeenSlider
const { setInitialised } = window.BAO.Carousel.plugins

const shopifySections = document.querySelectorAll('.shopify-section')
const productGrid = Array.from(shopifySections).find((section) =>
  section.id.includes('product-grid'),
)
const sectionWrapper = productGrid.id
const sectionElement = document.getElementById(sectionWrapper)
const prefix = 'shopify-section-'
const sectionId = sectionWrapper.replace(prefix, '')
const weddingCTA = document.querySelector('.sec-WeddingHero_Cta')

export class WeddingFilters extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)

    const filterElements = this.querySelectorAll('.sec-WeddingHero_StyleMedia')

    filterElements.forEach((element) => {
      element.addEventListener('click', this.handleFilterClick.bind(this))
    })

    weddingCTA.addEventListener('click', this.scrollToFilters)
  }

  handleResize () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView:
                this.els.slide.elements.length < 7
                  ? this.els.slide.elements.length
                  : 7,
              spacing: 10,
            },
          },
        },
      },
      [setInitialised()],
    )
  }

  scrollToFilters () {
    const targetElement = document.querySelector('#sec-WeddingHero_Styles')
    const offset = 200

    if (targetElement) {
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    }
  }

  scrollToProductGrid () {
    const targetElement = document.querySelector('.prd-List')
    const offset = 200

    if (targetElement) {
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      })
    }
  }

  async fetchFilteredProducts (filterParams) {
    // sectionElement.innerHTML = `<div class="loading-spinner">Loading...</div>`

    const currentUrl = new URL(window.location.href)
    const queryString = new URLSearchParams(filterParams).toString()
    const fetchUrl = `${currentUrl.pathname}?sections=${sectionId}&${queryString}`

    try {
      const response = await fetch(fetchUrl)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      sectionElement.innerHTML = data[sectionId]
      this.scrollToProductGrid()
    } catch (error) {
      console.error('Error loading products:', error)
    }
  }

  handleFilterClick (event) {
    const selectedFilterItem = event.target.closest('.sec-WeddingHero_Style')
    if (!selectedFilterItem || selectedFilterItem.dataset.disabled === 'true') {
      return
    }

    const filterItems = this.querySelectorAll('.sec-WeddingHero_Style')
    filterItems.forEach((item) => {
      item.classList.remove('sec-WeddingHero_Style-active')
    })

    selectedFilterItem.classList.add('sec-WeddingHero_Style-active')
    const filterParams = selectedFilterItem.dataset.filter
    this.fetchFilteredProducts(filterParams)
  }
}

if (!customElements.get('wedding-filters')) {
  customElements.define('wedding-filters', WeddingFilters)
}
